import { enums } from 'edrolo-ui';

enum MetadatumCategory {
  PRAC = 'PRAC',
  VIDEO = 'VIDEO',
  SLIDES = 'SLIDES',
  ASSESSMENT = 'assessment',
  FRAMEWORK = 'framework',
  RISK_ASSESSMENT = 'risk_assessment',
  STUDY_NOTES = 'study_notes',
  TEXTBOOK = 'textbook',
  UNIT_PLAN = 'unit_plan',
  WORKSHEET = 'worksheet',
  LESSON_SLIDES = 'lesson_slides',
  ACTIVITY = 'activity',
  QUESTION_SET = 'question_set',
  OTHER = 'OTHER', // TODO rename to OTHER_ATTACHMENT
}

interface Metadatum {
  title: string;
  count?: number | string | null;
  iconName: enums.Icons;
  color: enums.ColorHue | enums.ColorTheme;
  category: MetadatumCategory;
}

export { Metadatum, MetadatumCategory };
